module.exports = __webpack_public_path__ + "static/media/venus-double.d406987d.svg";